import React from 'react';
import theme from "../../theme";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles({

});

export default useStyles;